module.exports = __webpack_public_path__ + "img/31.8.TSS.fd7f35a5.png";